import { FieldStatus } from 'generated/graphql';

export const PhoneTypeOptions = [
  { name: 'Home', value: 'home' },
  { name: 'Work', value: 'work' },
  { name: 'Mobile', value: 'cell' }
];

export const EmailTypeOptions = [
  { name: 'Home', value: 'home' },
  { name: 'Work', value: 'work' }
];

export const ActionBuilderStatusOptionsAll = [
  { name: 'Confirmed', value: 'verified' },
  { name: 'User Added', value: 'user_added' },
  { name: 'Bad', value: 'bad' },
  { name: 'Do Not Contact', value: 'do_not_contact' },
];

export const GOOD_STATUSES = [
  FieldStatus.UserAdded,
  FieldStatus.Verified
];

export const CONTACT_SOURCES = {
  action_builder: {
    name: 'User Added',
    sortOrder: 0
  },
  upload: {
    name: 'Upload',
    sortOrder: 1
  },
  api: {
    name: 'API',
    sortOrder: 2
  },
  action_network: {
    name: 'Action Network',
    sortOrder: 3
  },
  voter_file: {
    name: 'Voter File',
    sortOrder: 4
  },
};

export const SOCIAL_NETWORK_SORT_ORDER = {
  discord: 0,
  facebook: 1,
  instagram: 2,
  linkedin: 3,
  tiktok: 4,
  twitter: 5,
  website: 6,
  wechat: 7,
  whatsapp: 8,
  other: 9,
};
